import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import template from 'url-template';

import { get } from 'lodash';

import TabPanel, { Tab, TabContent } from '../../components/TabPanel';
import ServiceStatusesTable from './ServiceStatusesTable';

import CustomersTable from './CustomersTable';
import TechniciansTable from './TechniciansTable';

import classes from './ERPAgentsPanel.module.css';

import * as ArchitectActions from '../../actions/architectActions';
import * as ErpAgentActions from '../../actions/erpAgentActions';
import * as DeviceActions from '../../actions/deviceActions';
import * as CoreActions from '../../actions/coreActions';

const ErpAgentsUrl = template.parse('/iothub/erpagents/configure{?company,erpAgent}');

const DEFAULT_PAGE_SIZE = 10;

const ErpAgentsPanel = ({
    companyInfo,
    customers,
    customersMeta,
    customerTrackingLoading,
    customersLoading,
    customerSearchValue,
    erpClientsLoading,
    fetchErpSites,
    fetchMappedErpClients,
    fetchMappedErpTechnicians,
    history,
    selectedAgent,
    setCustomerSearch,
    setProgressBarLoading,
    setTechnicianSearch,
    updateErpClient,
    updateErpTechnician,
    technicianTrackingLoading,
    technicians,
    techniciansLoading,
    techniciansMeta,
    technicianSearchValue
}) => {

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

    const [techPage, setTechPage] = useState(0);
    const [techPageSize, setTechPageSize] = useState(DEFAULT_PAGE_SIZE);

    useEffect(() => {
        const init = async selectedAgentId => {
            setProgressBarLoading(true);
            await fetchMappedErpClients(selectedAgentId, {page, pageSize});
            await fetchMappedErpTechnicians(selectedAgentId, {page: techPage, pageSize: techPageSize});
            setProgressBarLoading(false);
        };

        const selectedAgentId = get(selectedAgent, 'id');

        if (selectedAgentId) {
            init(selectedAgentId);
        }

    }, [selectedAgent]);

    useEffect(() => {
        const selectedAgentId = get(selectedAgent, 'id');
        const pageUpdate = page + 1;

        if (selectedAgentId) {
            fetchMappedErpClients(selectedAgentId, { page: pageUpdate, pageSize });
        }
    }, [page, pageSize]);

    useEffect(() => {
        const selectedAgentId = get(selectedAgent, 'id');
        const techPageUpdate = techPage + 1;

        if (selectedAgentId) {
            fetchMappedErpTechnicians(selectedAgentId, { page: techPageUpdate, pageSize: techPageSize });
        }
    }, [techPage, techPageSize]);

    useEffect(() => {
        const selectedAgentId = get(selectedAgent, 'id');

        if (selectedAgentId) {
            fetchMappedErpClients(selectedAgentId, { page, pageSize, searchFilter: customerSearchValue });
        }
    }, [customerSearchValue]);

    useEffect(() => {
        const selectedAgentId = get(selectedAgent, 'id');

        if (selectedAgentId) {
            fetchMappedErpTechnicians(selectedAgentId, { page: techPage, pageSize: techPageSize, searchFilter: technicianSearchValue });
        }
    }, [technicianSearchValue]);

    const handleConfigure = () => {
        const companyId = get(companyInfo, 'companyId', '');
        const erpAgentId = get(selectedAgent, 'id', '');

        history.push(ErpAgentsUrl.expand({
            company:  companyId,
            erpAgent: erpAgentId
        }));
    };

    return (
        <React.Fragment>
            <TabPanel
                aria-label="Rule Builder Options"
                classes={{
                    root: classes.ErpAgentsPanel
                }}
            >
                <Tab title="Customers">
                    <TabContent>
                        {
                            customers &&
                            <div className={classes.erpAgentsPanelContainer}>
                                <CustomersTable
                                    customers={customers}
                                    customersMeta={customersMeta}
                                    customerTrackingLoading={customerTrackingLoading}
                                    fetchErpSites={fetchErpSites}
                                    customersLoading={erpClientsLoading}
                                    handleConfigure={handleConfigure}
                                    selectedAgent={selectedAgent}
                                    updateErpClient={updateErpClient}
                                    onPageSet={setPage}
                                    onPageSizeSet={setPageSize}
                                    page={page}
                                    pageSize={pageSize}
                                    isLoading={customersLoading}
                                    setCustomerSearch={setCustomerSearch}
                                    customerSearchValue={customerSearchValue}
                                />
                            </div>
                        }
                    </TabContent>
                </Tab>
                <Tab title="Technicians">
                    <TabContent>
                        {
                            technicians &&
                            <div className={classes.erpAgentsPanelContainer}>
                                <TechniciansTable
                                    technicians={technicians}
                                    techniciansMeta={techniciansMeta}
                                    technicianTrackingLoading={technicianTrackingLoading}
                                    techniciansLoading={techniciansLoading}
                                    selectedAgent={selectedAgent}
                                    updateErpTechnician={updateErpTechnician}
                                    onPageSet={setTechPage}
                                    onPageSizeSet={setTechPageSize}
                                    page={techPage}
                                    pageSize={techPageSize}
                                    isLoading={techniciansLoading}
                                    setTechnicianSearch={setTechnicianSearch}
                                />
                            </div>
                        }
                    </TabContent>
                </Tab>
                <Tab title="Service Statuses">
                    <TabContent>
                        <div className={classes.erpAgentsPanelContainer}>
                            <ServiceStatusesTable />
                        </div>
                    </TabContent>
                </Tab>
            </TabPanel>
        </React.Fragment>
    );
};

const mapStateToProps = ({ architect, erpAgent, ...state }) => {
    const {
        erpAgents,
        customerTrackingLoading,
        customersLoading,
        customerSearchValue,
        erpClients,
        erpClientsMeta,
        erpTechnicians,
        erpTechniciansMeta,
        technicianSearchValue,
        technicianTrackingLoading,
        techniciansLoading
    } = erpAgent;

    return {
        companyInfo:        state.companyInfo,
        customerTrackingLoading,
        customers:          erpClients,
        customersMeta:      erpClientsMeta,
        customersLoading,
        customerSearchValue,
        erpAgents:          Object.values(erpAgents),
        erpClientsLoading:  architect.erpClientsLoading,
        progressBarLoading: state.core.progressBarLoading,
        technicianTrackingLoading,
        technicians:        erpTechnicians,
        techniciansMeta:    erpTechniciansMeta,
        techniciansLoading,
        technicianSearchValue
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...CoreActions,
    ...DeviceActions,
    ...ErpAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ErpAgentsPanel);
